import { useState } from 'react';
import { Banner, Text, Badge, InlineStack, BlockStack } from '@shopify/polaris';

export default function AcceptanceBanner({ acceptanceData }) {
  const [optionsOpen, setOptionsOpen] = useState(false);

  if (!acceptanceData) return null;

  const { SignatoryName, SignatoryEmail, SignatoryCompany, AcceptedAt, OptionSelections } = acceptanceData;
  const formattedDate = new Date(AcceptedAt).toLocaleDateString('nl-BE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });

  const hasOptions = OptionSelections && OptionSelections.length > 0;

  return (
    <div style={{ marginTop: '16px' }}>
      <Banner tone="success">
        <BlockStack gap="200">
          <Text as="p">
            Accepted by{' '}
            <Text as="span" fontWeight="semibold">
              {SignatoryName}
            </Text>{' '}
            ({SignatoryEmail}){SignatoryCompany ? ` — ${SignatoryCompany}` : ''} on {formattedDate}
          </Text>

          {hasOptions && (
            <>
              <div onClick={() => setOptionsOpen(!optionsOpen)} style={{ cursor: 'pointer', userSelect: 'none' }}>
                <Text as="span" variant="bodySm" fontWeight="semibold">
                  {optionsOpen ? '\u25BC' : '\u25B6'} Optional items ({OptionSelections.length})
                </Text>
              </div>
              {optionsOpen && (
                <BlockStack gap="100">
                  {OptionSelections.map((opt) => (
                    <InlineStack key={opt.ID} gap="200" blockAlign="center">
                      <Badge tone={opt.Accepted ? 'success' : 'critical'} size="small">
                        {opt.Accepted ? 'Accepted' : 'Declined'}
                      </Badge>
                      <Text as="span" variant="bodySm">
                        {opt.Line?.Description || `Line #${opt.QuotationLineID}`}
                      </Text>
                    </InlineStack>
                  ))}
                </BlockStack>
              )}
            </>
          )}

          <Text as="p" variant="bodySm" tone="subdued">
            This version is locked and cannot be edited.
          </Text>
        </BlockStack>
      </Banner>
    </div>
  );
}
